module.exports = __webpack_public_path__ + "img/shield-01.ad377e91.svg";